import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import ToastDialog from "../dialogs/ToastDialog/toast";
import BottomNavbar from "../other-components/BottomNavbar/Navbar";
import { openNewPage, copyText, AVATARS_ARR } from "../modals/Constants";
import { getStorage, deleteStorage } from "../modals/Storage";
import styles from "../css/Screens.module.css";
import general from "../css/General.module.css";

function Account() {
  const toastDialogRef = useRef(null);

  const navigate = useNavigate();
  const signOutAccount = () => {
    if (deleteStorage()) {
      navigate("/login", { replace: true });
    }
  };

  // toast component
  const onToastChange = (data, msg) => { };

  const showToast = (message, duration, delay, mode) => {
    toastDialogRef.current.openDialog(message, duration, delay, mode);
  };

  const copyMyId = () => {
    copyText(getStorage("uid"));
    showToast("ID Copied!", 2500, 0, 1);
  };

  useEffect(() => {
    if (!getStorage("uid")) {
      signOutAccount();
    }
  }, []);

  return (
    <div className={[general.viewCenter, general.appBackground].join(" ")}>
      <div
        className={[
          general.height100vh,
          general.respWidth,
          general.overflowScrollY,
          general.appContentsBackground,
          general.hideScrollBar,
        ].join(" ")}
      >
        <ToastDialog onToastChange={onToastChange} ref={toastDialogRef} />

        <div className="zoomAnimView">
          <div
            className={[
              styles.rowView,
              styles.alignFlexStart,
              styles.accountView,
            ].join(" ")}
          >
            <div
              className="h-w-70 ovf-hidden br-50"
              onClick={() => navigate("/updateaccount", { replace: false })}
            >
              {getStorage("avatarId") ? (
                <img
                  src={
                    AVATARS_ARR[Number(getStorage("avatarId")) - 1]["avatarURL"]
                  }
                  className="h-w-70"
                  alt="icon"
                />
              ) : (
                ""
              )}
            </div>

            <div className="col-view mg-l-15">
              <Link className="row-view txt-deco-n" to={"/changename"}>
                <div className="cl-white ft-wgt-500 ft-sz-1p25rem">
                  {getStorage("uname")}
                </div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="200"
                  height="200"
                  viewBox="0 0 200 200"
                  className="w-1p2-rem h-1p2-rem mg-l-10"
                  fill="#FFFFFF"
                >
                  <path d="M135.554 41.667v12.5h-89.72v91.666h99.999V100h12.5v45.833a12.5 12.5 0 0 1-12.5 12.5h-100a12.5 12.5 0 0 1-12.5-12.5V54.167a12.5 12.5 0 0 1 12.5-12.5h89.721Zm26.709 4.733 8.808 8.867-67.133 66.658.025.025-9.1.308.258-9.233.017.021L162.262 46.4Z"></path>
                </svg>
              </Link>

              <div
                className={[general.widthFitContent, general.colorWhite, general.fontS14Px, general.pd0px5px, general.borderRadius, general.bgCustomColor8].join(" ")}
                onClick={() => copyMyId()}
              >
                UID &nbsp; | &nbsp; {getStorage("uid")}
                <img
                  src={require("../icons/copy_icon.png")}
                  className="h-10-p mg-l-15"
                  alt="icon"
                />
              </div>
              <div className="cl-white ft-sz-14 mg-t-5">
                Last Active: {getStorage("accountLastActive")}
              </div>
            </div>
          </div>

          <div
            className={[styles.accountOptionsView, styles.colView].join(" ")}
          >
            <div className="w-100 z-i-1">
              <div
                className={[styles.colView, styles.accountBalanceView].join(
                  " "
                )}
              >
                <span className="cl-black">Account Balance:</span>
                <span className="cl-black ft-sz-23">
                  ₹{Number(getStorage("balance")).toLocaleString()}
                </span>

                <div className="line-hv-grey mg-t-10"></div>

                <div
                  className={[styles.rowView, styles.spaceBetween].join(" ")}
                >
                  <Link className={[general.textDecoNone, general.colView, general.viewCenter].join(" ")} to={"/wallet/recharge"}>
                  <svg className="h-w-28" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60" fill="none">
    <path d="M37.5 15.3789H15C9.475 15.3789 5 19.8539 5 25.3789V16.3539C5 11.2539 9.125 7.12891 14.225 7.12891H28.275C33.375 7.12891 37.5 10.2789 37.5 15.3789Z" fill="#F95959"></path>
    <path opacity="0.4" d="M43.7 30.4961C42.45 31.7211 41.85 33.5711 42.35 35.4461C42.975 37.7711 45.275 39.2461 47.675 39.2461H50V42.8711C50 48.3961 45.525 52.8711 40 52.8711H15C9.475 52.8711 5 48.3961 5 42.8711V25.3711C5 19.8461 9.475 15.3711 15 15.3711H40C45.5 15.3711 50 19.8711 50 25.3711V28.9961H47.3C45.9 28.9961 44.625 29.5461 43.7 30.4961Z" fill="#F95959"></path>
    <path d="M55 31.5561V36.7061C55 38.1061 53.85 39.2561 52.425 39.2561H47.6C44.9 39.2561 42.425 37.2811 42.2 34.5811C42.05 33.0061 42.65 31.5311 43.7 30.5061C44.625 29.5561 45.9 29.0061 47.3 29.0061H52.425C53.85 29.0061 55 30.1561 55 31.5561ZM32.5 29.7461H17.5C16.475 29.7461 15.625 28.8961 15.625 27.8711C15.625 26.8461 16.475 25.9961 17.5 25.9961H32.5C33.525 25.9961 34.375 26.8461 34.375 27.8711C34.375 28.8961 33.525 29.7461 32.5 29.7461Z" fill="#F95959"></path>
</svg>
                    <span className={[general.colorblack, general.fontS15Px].join(" ")}>
                      Wallet
                    </span>
                  </Link>
                  <Link
                    className="txt-deco-n col-view v-center"
                    to={"/wallet/recharge"}
                  >
                    <img
                      src={require("../media/icons/deposit_icon.png")}
                      className="h-w-28"
                      alt="icon"
                    />
                    <span className="cl-black ft-sz-15">Deposit</span>
                  </Link>

                  <Link
                    className="txt-deco-n col-view v-center"
                    to={"/withdraw"}
                  >
                    <img
                      src={require("../media/icons/withdrawl_icon.png")}
                      className="h-w-28"
                      alt="icon"
                    />
                    <span className="cl-black ft-sz-15">Withdraw</span>
                  </Link>

                  <Link className={[general.textDecoNone, general.colView, general.viewCenter].join(" ")}>
                    <img
                      src={require("../media/icons/vip_icon.png")}
                      className="h-w-28"
                      alt="icon"
                    />
                    <span className={[general.colorblack, general.fontS15Px].join(" ")}>
                      Vip
                    </span>
                  </Link>
                </div>
              </div>
            </div>

            <div className={[styles.accountShortCutOptionsView]}>
              <Link className={[styles.rowView]} to={"/rechargerecords"}>
                <img
                  src={require("../media/icons/deposit_history_icon.png")}
                  alt="icon"
                />
                <div className="col-view mg-l-5">
                  <span className={[styles.fontS17Px]}>Deposit</span>
                  <span
                    className={[styles.fontS12Px, styles.colorLightWhite].join(
                      " "
                    )}
                  >
                    My Deposit History
                  </span>
                </div>
              </Link>

              <Link
                className="txt-deco-n row-view pd-15-10 br-10 bg-white"
                to={"/withdrawrecords"}
              >
                <img
                  src={require("../media/icons/withdrawl_history_icon.png")}
                  alt="icon"
                />
                <div className="col-view mg-l-5">
                  <span className={[styles.fontS17Px]}>Withdraw</span>
                  <span
                    className={[styles.fontS12Px, styles.colorLightWhite].join(
                      " "
                    )}
                  >
                    My Withdraw History
                  </span>
                </div>
              </Link>

              <Link
                className="txt-deco-n row-view pd-15-10 br-10 bg-white"
                to={"/myorders"}
              >
                <img
                  src={require("../media/icons/bet_history_icon.png")}
                  alt="icon"
                />
                <div className="col-view mg-l-5">
                  <span className={[styles.fontS17Px]}>Bet</span>
                  <span
                    className={[styles.fontS12Px, styles.colorLightWhite].join(
                      " "
                    )}
                  >
                    My Bet History
                  </span>
                </div>
              </Link>

              <Link
                className="txt-deco-n row-view pd-15-10 br-10 bg-white"
                to={"/transactions"}
              >
                <img
                  src={require("../media/icons/transactions_icon.png")}
                  alt="icon"
                />
                <div className="col-view mg-l-5">
                  <span className={[styles.fontS17Px]}>Transactions</span>
                  <span
                    className={[styles.fontS12Px, styles.colorLightWhite].join(
                      " "
                    )}
                  >
                    My Transactions History
                  </span>
                </div>
              </Link>
            </div>

            <div
              className={[styles.accountMoreOptionsView].join(
                " "
              )}
            >
         


              <Link
                className={[
                  styles.rowView,
                  styles.spaceBetween,
                  Number(getStorage("accountLevel")) <= 2
                    ? styles.hideView
                    : "",
                ].join(" ")}
                to={"/agentreports"}
              >
                <div className={[styles.viewCenter]}>
                  <img
                    src={require("../media/icons/agent_transactions_icon.png")}
                    alt="icon"
                  />
                  <span>Agent Report</span>
                </div>

                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  className="tranf-rotate-180"
                  fill="#FFFFFF"
                >
                  <path d="M10.307 14.5 3.807 8l6.5-6.5 1.886 1.886L7.58 8l4.614 4.614-1.886 1.886Z"></path>
                </svg>
              </Link>

              <Link
  className={[styles.rowView, styles.spaceBetween].join(" ")}
  onClick={() => openNewPage("https://t.me/Leo99spots")}
>
  <div className={[styles.viewCenter]}>
    <img
      src={require("../media/icons/live_support_icon.png")}
      alt="icon"
    />
    <span>Live Support</span>
  </div>

  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    className="tranf-rotate-180"
    fill="#FFFFFF"
  >
    <path d="M10.307 14.5 3.807 8l6.5-6.5 1.886 1.886L7.58 8l4.614 4.614-1.886 1.886Z"></path>
  </svg>
</Link>

              <Link
                className={[styles.rowView, styles.spaceBetween].join(" ")}
                to={"/redeemgiftcard"}
              >
                <div className={[styles.viewCenter]}>
                  <img
                    src={require("../media/icons/gift_icon.png")}
                    alt="icon"
                  />
                  <span>Redeem Gift</span>
                </div>

                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  className="tranf-rotate-180"
                  fill="#FFFFFF"
                >
                  <path d="M10.307 14.5 3.807 8l6.5-6.5 1.886 1.886L7.58 8l4.614 4.614-1.886 1.886Z"></path>
                </svg>
              </Link>

              <Link
                className={[styles.rowView, styles.spaceBetween].join(" ")}
                to={"/devicemanager"}
              >
                <div className={[styles.viewCenter]}>
                  <img
                    src={require("../media/icons/device_manager_icon.png")}
                    alt="icon"
                  />
                  <span>Device Manager</span>
                </div>

                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  className="tranf-rotate-180"
                  fill="#FFFFFF"
                >
                  <path d="M10.307 14.5 3.807 8l6.5-6.5 1.886 1.886L7.58 8l4.614 4.614-1.886 1.886Z"></path>
                </svg>
              </Link>
              <Link
  className={[styles.rowView, styles.spaceBetween].join(" ")}
  onClick={() => openNewPage("https://t.me/Leo99spots")}
>
                <div className={[styles.viewCenter]}>
                  <img
                    src={require("../media/icons/notification_icon.png")}
                    alt="icon"
                  />
                  <span>Telegram</span>
                </div>

                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  className="tranf-rotate-180"
                  fill="#FFFFFF"
                >
                  <path d="M10.307 14.5 3.807 8l6.5-6.5 1.886 1.886L7.58 8l4.614 4.614-1.886 1.886Z"></path>
                </svg>
              </Link>


              <Link
                className={[styles.rowView, styles.spaceBetween].join(" ")}
                to={"/Announcement"}
              >
                <div className={[styles.viewCenter]}>
                  <img
                    src={require("../media/icons/statistics_icon.png")}
                    alt="icon"
                  />
                  <span>Announcement</span>
                </div>

                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  className="tranf-rotate-180"
                  fill="#FFFFFF"
                >
                  <path d="M10.307 14.5 3.807 8l6.5-6.5 1.886 1.886L7.58 8l4.614 4.614-1.886 1.886Z"></path>
                </svg>
              </Link>


            

              <Link
                className={[styles.rowView, styles.spaceBetween].join(" ")}
                to={"/Feedback"}
              >
                <div className={[styles.viewCenter]}>
                  <img
                    src={require("../media/icons/agent_transactions_icon.png")}
                    alt="icon"
                  />
                  <span>Feedback</span>
                </div>

                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  className="tranf-rotate-180"
                  fill="#FFFFFF"
                >
                  <path d="M10.307 14.5 3.807 8l6.5-6.5 1.886 1.886L7.58 8l4.614 4.614-1.886 1.886Z"></path>
                </svg>
              </Link>
              
              <Link
                className={[
                  styles.rowView,
                  styles.spaceBetween,
                  Number(getStorage("accountLevel")) <= 2
                    ? styles.hideView
                    : "",
                ].join(" ")}
                to={"/agentreports"}
              >
                <div className={[styles.viewCenter]}>
                  <img
                    src={require("../media/icons/agent_transactions_icon.png")}
                    alt="icon"
                  />
                  <span>Agent Report</span>
                </div>

                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  className="tranf-rotate-180"
                  fill="#FFFFFF"
                >
                  <path d="M10.307 14.5 3.807 8l6.5-6.5 1.886 1.886L7.58 8l4.614 4.614-1.886 1.886Z"></path>
                </svg>
              </Link>

            </div>
            <div className={[general.pd10px]}>
              <div
                className={[
                  general.Accountlogout,
                ].join(" ")}
                onClick={() => signOutAccount()}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="20" viewBox="0 0 48 48" fill="none">
                  <path
                    d="M14.5 8C13.8406 8.37652 13.2062 8.79103 12.6 9.24051C11.5625 10.0097 10.6074  10.8814 9.75 11.8402C6.79377 15.1463 5 19.4891 5 24.2455C5 34.6033 13.5066 43 24 43C34.4934 43 43 34.6033 43 24.2455C43 19.4891 41.2062 15.1463 38.25 11.8402C37.3926 10.8814 36.4375 10.0097 35.4 9.24051C34.7938 8.79103 34.1594 8.37652 33.5 8"
                    stroke="#61a9ff"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M24 4V24"
                    stroke="#61a9ff"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <div className="v-center">
                  <span className="mg-l-10">Log Out</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <BottomNavbar activeBar="account" />
      </div>
    </div>
  );
}

export default Account;
